module.exports = __webpack_public_path__ + "static/media/NeoSans-Bold.91ec2fd5.ttf";